import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { LanguageSkillListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialLanguageSkillList } from '../../logics/languageSkill/createInitialLanguageSkillList';

/**
 * 語学に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useLanguageSkillList = (args: HooksArgument) => {
  const [languageSkillList, setLanguageSkillList] = useState<
    LanguageSkillListType[]
  >(createInitialLanguageSkillList(args));

  const selectedLanguageSkillList = useMemo(() => {
    return languageSkillList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [languageSkillList]);

  // チェック状態更新処理
  const updateIsCheckedLanguageSkillList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = languageSkillList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setLanguageSkillList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [languageSkillList]
  );

  // 求人件数更新処理
  const updateLanguageListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setLanguageSkillList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    languageSkillList,
    selectedLanguageSkillList,
    updateIsCheckedLanguageSkillList,
    updateLanguageListJobCount,
  };
};
